import { render, staticRenderFns } from "./TurmaRow.vue?vue&type=template&id=fc7799a4&scoped=true&"
import script from "./TurmaRow.vue?vue&type=script&lang=js&"
export * from "./TurmaRow.vue?vue&type=script&lang=js&"
import style0 from "./TurmaRow.vue?vue&type=style&index=0&id=fc7799a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7799a4",
  null
  
)

export default component.exports